import SpotlightElement from "./SpotlightElementRoot.vue"

export default SpotlightElement
